var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-loading-status",attrs:{"role":"status","aria-live":"polite"}},[_c('v-progress-circular',{staticClass:"inline-loading-status__spinner",attrs:{"indeterminate":"","size":24,"width":3,"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.displayMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }